<p-dropdown [options]="lista" placeholder="Selecione o Responsável" optionLabel="text" (onChange)="feedback($event)"
    [disabled]="disabled" [style]="{'width':'100%'}" [filter]="true" [showClear]="true">
</p-dropdown>